module.exports = __webpack_public_path__ + "img/qr-code-wxsubscription.6656b977.png";